export default {
  header: {
    title: 'Etukoodi tai lahjakortti',
  },
  available_codes: {
    title_one: 'Saatavilla oleva koodi ({{count}})',
    title_other: 'Saatavilla olevat koodit ({{count}})',
    min_threshold: 'Väh. {{value}}',
    percentage_off: '{{discount}} % alennus tästä tilauksesta',
    amount_off: '{{amount}} alennus tästä tilauksesta',
  },
  content: {
    input: {
      placeholder: 'Syötä koodi',
    },
    buttons: {
      done: 'Valmis',
      apply: 'Käytä',
      applied: 'Käytetty ✓',
    },
  },
};
